"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchPriceFinder;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _react2 = require("react");
var _LocationPicker = _interopRequireDefault(require("../LocationPicker"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FIELDS = {
  location: 'location'
};
function SearchPriceFinder(_ref) {
  var {
    defaultLocation,
    partialTranslations,
    AEMTranslations,
    screenSize,
    suggestions,
    onIsSearchActive,
    onLocationInputChange,
    onLocationInputClear,
    onLocationInputFocus,
    searchPriceFinderStyles,
    errorField,
    errorMessage,
    searchDisabled = false,
    handleLocationSearch,
    setLocationName
  } = _ref;
  var {
    isLessThanLg,
    isLessThanMd,
    isLessThanSm
  } = screenSize;
  var [location, setLocation] = (0, _react2.useState)(undefined);
  var {
    searchWrapper,
    locationPickerStyles,
    inputGroupStyles,
    inputElementStyles,
    errorInputGroupStyles,
    errorInputElementStyles,
    errorMarginBottom,
    buttonStyles
  } = searchPriceFinderStyles;
  var autocompleteStyles = _objectSpread({
    locationPickerStyles,
    inputGroupStyles,
    inputElementStyles,
    errorMarginBottom
  }, errorField === FIELDS.location && {
    errorInputGroupStyles,
    errorInputElementStyles
  });
  var handleOnClick = () => {
    if (handleLocationSearch && setLocationName && location && 'placeId' in location) {
      handleLocationSearch(location.placeId);
      setLocationName(location === null || location === void 0 ? void 0 : location.suggestion);
    }
  };
  return (0, _jsxRuntime.jsx)(_react.Flex, {
    direction: "column",
    alignItems: "center",
    children: (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({
      align: "center",
      bgColor: "baseWhite"
    }, searchWrapper), {}, {
      "data-testid": "search-component",
      onFocus: () => {
        if (onIsSearchActive) {
          onIsSearchActive(true);
        }
      },
      children: [(0, _jsxRuntime.jsx)(_LocationPicker.default, _objectSpread(_objectSpread({}, locationPickerStyles), {}, {
        inputPlaceholder: AEMTranslations.priceFinderLocationPlaceholder || getLocationPlaceholder(),
        defaultInputValue: defaultLocation,
        isLocationRequired: true,
        hasListDivider: false,
        styles: autocompleteStyles,
        onSelectLocation: handleSelectLocation,
        suggestions: suggestions,
        onInputChange: onLocationInputChange,
        onInputClear: onLocationInputClear,
        onInputFocus: onLocationInputFocus,
        isPriceFinder: true
      }, errorField === FIELDS.location && {
        showErrorMessage: true,
        errorMessage: errorMessage
      })), (0, _jsxRuntime.jsx)(_atoms.Button, _objectSpread(_objectSpread({
        size: "md",
        variant: "primary",
        name: "search-button",
        "data-testid": "search-component-button",
        isDisabled: searchDisabled
      }, buttonStyles), {}, {
        mt: {
          base: '0',
          sm: '0'
        },
        onClick: handleOnClick,
        children: getButtonContent()
      }))]
    }))
  });
  function handleSelectLocation(location) {
    setLocation(location);
  }
  function getLocationPlaceholder() {
    var _partialTranslations$;
    return isLessThanLg && !isLessThanSm ? AEMTranslations.locationPlaceholder : partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$ = partialTranslations.form) === null || _partialTranslations$ === void 0 ? void 0 : _partialTranslations$.where;
  }
  function getButtonContent() {
    return isLessThanMd ? (0, _jsxRuntime.jsx)(_atoms.Icon, {
      svg: (0, _jsxRuntime.jsx)(_atoms.SearchIcon, {
        color: "var(--chakra-colors-baseWhite)"
      })
    }) : AEMTranslations.submitButtonLabel;
  }
}